import {ordersApi} from './Api';

const OrderService = (() => {
	function updateUserReserve(params: any) {
		return ordersApi.put(`/v2/checkout/reservation/user`, {}, { params });
	}

	return {
		updateUserReserve: updateUserReserve
	}
})();

export default OrderService;
